// 埋点SDN路径
export const wxSdkUrl: any = {
    m: 'https://tracklog.58.com/referrer_m.js',
    pc: 'https://tracklog.58.com/referrer4.js',
    miniProgram: 'https://tracklog.58.com/referrer4.js'
};

// p1 = p7
export const PKeys = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8'];
export const optionKeys = ['realtime', 'top_level', 'cate', 'bizLine'];
